import { render, staticRenderFns } from "./PhoneNumberPorting.vue?vue&type=template&id=10121880&scoped=true&"
import script from "./PhoneNumberPorting.vue?vue&type=script&lang=js&"
export * from "./PhoneNumberPorting.vue?vue&type=script&lang=js&"
import style0 from "./PhoneNumberPorting.vue?vue&type=style&index=0&id=10121880&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10121880",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
